import React from 'react';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../utils/MouseUtils';
import properties from "../../constants/Properties";

export const PrimaryMenuButton = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.clickHandler)
            this.props.clickHandler(this.props.type);
    },
    render() {
        var buttonStyle = {
            borderRadius: '8px',
            margin: '1% 0',
            height: '35px',
            backgroundColor: 'white',
            maxWidth: '49%',
            width: '100%',
            border: '2px solid rgb(67, 67, 67)',
            cursor: 'pointer'
        };

        var selectedButtonStyle = {
            borderRadius: '8px',
            margin: '1% 0',
            height: '35px',
            backgroundColor: 'rgb(67, 67, 67)',
            color: 'white',
            maxWidth: '49%',
            width: '100%',
            border: '2px solid rgb(67, 67, 67)',
            cursor: 'pointer'
        };

        if (this.props.targets >= 2) {
            let value;

            if (this.props.targets > 5)
                value = 19;
            else
                value = Math.floor(100 / this.props.targets) - 1;

            buttonStyle.maxWidth = value + '%';
            selectedButtonStyle.maxWidth = value + '%';

            buttonStyle.marginRight = '1%';
            selectedButtonStyle.marginRight = '1%';
        }

        if (this.state.isOver == true) {
            buttonStyle.borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            buttonStyle.color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

            selectedButtonStyle.color = 'lightgoldenrodyellow';
        }

        return (
            <button id={this.props.id} aria-label={this.props.caption} style={this.props.isSelected ? selectedButtonStyle : buttonStyle} onClick={this.onClick} onTouchStart={this.onClick} aria-pressed={this.props.isToggleButton ? this.props.isSelected : undefined} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                {this.props.caption}
            </button>
        );
    }
});

export const SecondaryMenuButton = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.clickHandler)
            this.props.clickHandler(this.props.type);
    },
    render() {
        var buttonStyle = {
            borderRadius: '20px',
            margin: '1% 0',
            height: '35px',
            backgroundColor: '#E6E6E6',
            maxWidth: '49%',
            width: '100%',
            border: '2px solid rgb(67, 67, 67)',
            cursor: 'pointer'
        };

        if (this.state.isOver == true) {
            buttonStyle.borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            buttonStyle.color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }

        return (
            <button id={this.props.id} aria-label={this.props.caption} style={buttonStyle} onClick={this.onClick} onTouchStart={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                {this.props.caption}
            </button>
        );
    }
});

export const MenuInput = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onChangeHandler() {
        if (this.props.onChangeHandler) {
            if (this.props.property && (this.props.xValue || this.props.yValue)) {
                if (this.props.xValue)
                    this.props.onChangeHandler(this.props.xValue, this.refs.inputField.value, this.props.property);
                else
                    this.props.onChangeHandler(this.refs.inputField.value, this.props.yValue, this.props.property);
            } else {
                if (this.props.property)
                    this.props.onChangeHandler(this.props.property, this.refs.inputField.value);
                else {
                    if (this.props.xValue || this.props.yValue) {
                        if (this.props.xValue)
                            this.props.onChangeHandler(this.props.xValue, this.refs.inputField.value);
                        else
                            this.props.onChangeHandler(this.refs.inputField.value, this.props.yValue);
                    } else
                        this.props.onChangeHandler(this.refs.inputField.value);
                }
            }
        }
    },
    onSetTextFocus() {
        setTimeout(function() {
            if (this.refs.inputField) {
                this.refs.inputField.focus();
                // this.refs.inputField.setSelectionRange(0, 100);
            }
        }.bind(this), 10);
    },
    onFocusHandler() {
        if (this.props.onFocusHandler)
            this.props.onFocusHandler(this.props.property);
    },
    onBlurHandler() {
        if (this.props.onBlurHandler)
            this.props.onBlurHandler(this.props.property);
    },
    render() {
        const labelStyle = {
            fontSize: '16px',
            margin: '2% 0',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            top: 0
        };

        var inputStyle = {
            borderRadius: '5px',
            fontSize: '18px',
            border: '2px solid black',
            background: 'transparent',
            width: '50px'
        };

        if (this.state.isOver == true) {
            inputStyle.color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }

        return (
            <label style={labelStyle}>
                <span style={labelStyle}>{this.props.labelText}</span>
                <input id={this.props.id} style={inputStyle} ref='inputField' onChange={this.onChangeHandler} onTouchStart={this.onSetTextFocus} type='text' className='titleInput' value={this.props.isInt ? Math.round(parseInt(this.props.value)) || 0 : this.props.value} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off' onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onFocus={this.onFocusHandler} onBlur={this.onBlurHandler}/>
            </label>
        );
    }
});

export const MenuCheckbox = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.clickHandler)
            this.props.clickHandler();
    },
    render() {
        const labelStyle = {
            fontSize: '16px',
            margin: '2% 0',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            top: 0
        };

        var caption = this.props.value ? locales.getCaption('On', 'sizePosMenu') : locales.getCaption('Off', 'sizePosMenu');

        var buttonStyle = {
            cursor: 'pointer'
        };

        if (this.state.isOver == true) {
            buttonStyle.color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }

        return (
            <label style={labelStyle}>
                <span style={labelStyle}>{this.props.labelText}</span>
                <button id={this.props.id} role='checkbox' style={buttonStyle} aria-label={caption} aria-checked={this.props.value} onClick={this.onClick} onTouchStart={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                {
                    caption
                }
                </button>
            </label>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/SizeAndPositionButtons.js
 **/